export default __webpack_public_path__ + "static/media/Snowflake.37c60f84.svg";